<template>
	<div class="pre-checkout-container">
		<template v-if="dialog">
			<v-dialog
				v-model="dialog"
				content-class="cancel-order-modal">
				<v-card>
					<v-card-title>
						<div class="popup-wrapper">
							<v-container>
								<v-flex xs12 class="close-image">
									<img class="delivery-image" :src=deliveryChoice.href.white>
									<div class="popup-title">{{$t("shopComponents.gt3.shoppingCart.shoppingCartWrapper.popupMessage")}}</div>
									<div class="popup-subtitle">{{$t("shopComponents.gt3.shoppingCart.shoppingCartWrapper.popupSubtitle")}} </div>
								</v-flex>
								<v-flex>
									<div class="buttons-wrapper">
										<v-card-actions>
											<v-btn
												class="back-btn"
												@click="dialog = false"
											>
												{{$t("shopComponents.gt3.shoppingCart.shoppingCartWrapper.back")}}
											</v-btn>

											<v-btn
												class="quit-btn"
												@click="clearBasket"
											>
												{{$t("shopComponents.gt3.shoppingCart.shoppingCartWrapper.interrupt")}}
											</v-btn>
										</v-card-actions>
									</div>
								</v-flex>
							</v-container>
							<div class="close-btn" @click="dialog=false"></div>
						</div>
					</v-card-title>
				</v-card>
			</v-dialog>
		</template>
		<div class="v-kiosk-basket-header">
			{{$t("shopComponents.gt3.shoppingCart.shoppingCartWrapper.myOrderTitle")}}: {{ formatPriceZero(totalPrice) }}
		</div>
		<div class="pre-checkout-content">
			<div class="pre-checkout-content__items">
				<shopping-cart-checkout-init
					data-cy="shoppingCart"
					:is-voucher="true"
					:deliveryChoice="deliveryChoice"
					:isProductConfiguring="isProductConfiguring"/>
			</div>
			<shopping-cart-bottom-stepper
				:class="(cartProducts.length > 0 ? 'non-empty-basket' : 'empty-basket')"
				class="stepper-wrapper"
				:goToPayment="goToPayment"
				:addToBasket="addToBasket"
				@cancelOrdering="cancelOrdering"
				@showUpsellModal="upsellModalControl"
			/>
		</div>
		<div class="bottom-tip">
			<div class="bottom-tip__content">
				<img src="static/gt3/kiosk/images/icons/qr-code-phone.svg">
				<div class="bottom-tip__title">{{$t("shopComponents.gt3.scanner.title")}}<span>{{$t("shopComponents.gt3.scanner.titleBold")}}</span></div>
				<div class="bottom-tip__desc">{{$t("shopComponents.gt3.scanner.getDiscount")}}</div>
			</div>
			<div class="bottom-tip__pointer">
				<svg width="105" height="74" viewBox="0 0 105 74" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect x="31" width="45.7059" height="21.7647" fill="#e8e8e8"/>
					<path d="M52.7647 74L7.52764 21.7647L98.0018 21.7647L52.7647 74Z" fill="#e8e8e8"/>
				</svg>
			</div>
		</div>
	</div>
</template>

<script>
import ShoppingCartBottomStepper from "./ShoppingCart/ShoppingCartBottomStepper-gt3";
import {mapGetters} from "vuex";
import ShoppingCartCheckoutInit from "./ShoppingCart/ShoppingCartCheckoutInit-gt3";
import UpsellRules from "./ShoppingCart/UpsellRules-gt3";
import appConfig from "../../../appconfig";
const tenantConfig = appConfig.tenantConfig;
import * as Utils from "../../../libraries/utils";
import * as actions from "../../../store/mutation-types";
import {formatPriceZero} from "../../../domains2/libraries/Utils";
export default {
	name: "PreCheckout-gt3",
	components: {
		ShoppingCartCheckoutInit,
		ShoppingCartBottomStepper,
		UpsellRules
	},
	props: ["isProductConfiguring"],
	data() {
		return {
			categories: [],
			dialog: false,
			displayUpsellModal: false,
			goToPayment: false,
			addToBasket: false,
			basketExpanded: false
		};
	},
	computed: {
		...mapGetters(["cartProducts", "getCurrentStep", "tenantSpecificData", "featureToggles", "totalPrice"]),

		channel() {
			return appConfig.channelAlias();
		},
		deliveryChoice() {
			const self = this;
			const channelFolder = self.channel === "desktopBrowser" ? "desktop" : self.channel;
			const deliveryChoices = [
				{
					id: 0,
					title: self.$t(`shopComponents.gt3.shoppingCart.shoppingCartWrapper.eatIn.${self.channel}`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/eat-in-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/eat-in-white.svg`
					}
				},
				{
					id: 1,
					title: self.$t(`shopComponents.gt3.shoppingCart.shoppingCartWrapper.parkingPickup.${self.channel}`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/parking-pickup-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/parking-pickup-white.svg`
					}
				},
				{
					id: 2,
					title: self.$t(`shopComponents.gt3.shoppingCart.shoppingCartWrapper.takeOut.${self.channel}`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-white.svg`
					}
				},
				{
					id: 3,
					title: self.$t(`shopComponents.gt3.shoppingCart.shoppingCartWrapper.delivery.desktopBrowser`),
					href: {
						black: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-black.svg`,
						white: `${Utils.getAwsStaticPath()}${channelFolder}/images/icons/to-go-white.svg`
					}
				}
			];
			return deliveryChoices.find(item => item.id === self.tenantSpecificData.deliveryChoice);
		},
		isUpsellRulesEnabled() {
			return !!this.featureToggles.crossSellRules;
		}
	},
	methods: {
		toggleBasketViewState() {
			this.basketExpanded = !this.basketExpanded;
		},
		cancelOrdering() {
			this.dialog = true;
		},
		formatPriceZero,
		clearBasket() {
			const self = this;
			self.$store.dispatch(actions.CART_EMPTY_ALL).then(()=>{
				self.$router.push(tenantConfig.shopHomepage);
			});
		},
		upsellModalControl() {
			this.displayUpsellModal = !this.displayUpsellModal;
			if(!this.displayUpsellModal) {
				this.goToPayment = true;
			}
		},
		getAddToBasket(value) {
			this.addToBasket = value;
		}
	}
};
</script>

<style lang="scss" scoped>
.pre-checkout-container {
	$height: 1920px - 326px;
	position: fixed;
	top: 0;
	color: #fff;
	background-color: #f6f6f6;
	z-index: 2;
	margin-top: 326px;
	width: 1080px;
	min-height: $height;
	height: $height;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;

	.v-kiosk-basket-header {
		width: 100%;
		padding: 15px;
		background-color: #e8e8e8;
		color: #000;
		font-size: 1.5rem;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.pre-checkout-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		height: calc(100vh - 62px);
		width: 100%;

		.items-wrapper {
			width: 600px;
			//height: 1392px !important;
			height: unset !important;
			.v-card {
				margin-top: 16px !important;
			}
		}

		&__items {
			height: 1392px !important;
			overflow-y: auto;
		}

		.voucher-part {
			color: #000 !important;
			bottom: -2px !important;
		}

		.shopping-cart-bottom-stepper {
			position: relative !important;
			display: flex;
			justify-content: space-between;
			padding: 0 16px;
			width: 100%;
			.btn-order {
				width: 40% !important;

				&.cancel-order-btn {
					background-color: white !important;
					color: #999999;

					.btn-layout {
						justify-content: center !important;
						align-items: center;
					}

					.cross {
						background-color: #E8E8E8;
						border-radius: 50%;
					}
				}
			}
		}


	}
}

.bottom-tip {
	position: absolute;
	width: 300px;
	height: 170px;
	left: 16px;
	bottom: 130px;
	display: flex;
	border-radius: 10px;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	&__content {
		background-color: #e8e8e8;
		border-radius: 10px;
		color: black;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 8px 0;
		height: 100%;
		width: 100%;
		img {
			width: 74px;
		}
	}
	&__title {
		font-size: 20px;
		span {
			color: #218c74;
		}
	}
	&__desc {
		font-size: 16px;
		width: 88%;
		text-align: center;
	}
	&__pointer {
		margin-top: -10px;
		svg {
			transform: scale(0.8);
		}
	}
}

.v-dialog__container{
	display: flex !important;
	justify-content: flex-end;
}
.v-card__title{
	padding: 0;
	background-color: #000000;
	.container{
		width: 722px;
		height: 423px;
		border-radius: 5px;
		box-shadow: 0 0 50px 20px rgba(72, 72, 72, 0.23);
		border: solid 3px #26282c;
		background-color: #000000;
		color: #FFFFFF;
		padding: 0;
		.v-card__actions{
			justify-content: center;
			padding-top: 40px;
			.v-btn{
				width: 220px;
				height: 50px;
			}
			.back-btn{
				border-radius: 3px;
				border: solid 2px #26282c;
				font-family: Dispatch-Bold;
				font-size: 22px;
				font-weight: bold;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				text-align: center;
				color: #ffffff;
				background-color: transparent;
			}
			.quit-btn{
				border-radius: 3px;
				border: solid 2px #ffd800;
				background-color: #ffd800;
				font-family: Dispatch-Bold;
				font-size: 22px;
				font-weight: bold;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				text-align: center;
				color: #000000;
				margin-left: 16px;
			}
		}
		.close-image{
			margin-top: 60px;
			text-align: center;
			justify-content: center;
			.delivery-image{
				width: 112px;
				height: 103px;
			}
			.popup-title{
				font-family: Dispatch;
				font-size: 24px;
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				text-align: center;
				color: #ffffff;
				text-transform: uppercase;
				margin-top: 21px;
				margin-bottom: 16px;
			}
			.popup-subtitle{
				font-family: Dispatch;
				font-size: 18px;
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: normal;
				text-align: center;
				color: #ffffff;
				max-width: 316px;
				margin: auto;
			}
		}
	}
}
.background-color-basket {
	background-color: white;
}
@media (max-width:1024px) {
	div.seperator {
		height:2em;
	}
}

div /deep/ {
	.checkout-title {

	}
	.title-separator {
		margin: 0 0 16px 0;
	}
}
@media screen and (min-width: 600px) {
	display: block;
}

@media screen and (min-width: 600px) {
	.v-stepper {
		box-shadow: none;

		.v-stepper__step {
			padding: 0;
		}
		.v-stepper__step__step {
			background-color: #f5f5f5 !important;

			height: 8px;
			width: 8px;
			font-size: 1px;
		}
		.v-stepper__step.v-stepper__step--inactive .v-stepper__step__step {
			background-color: #f5f5f5 !important;
			color: #f5f5f5 !important;
		}
		.v-stepper__step.v-stepper__step--active .v-stepper__step__step {
			background-color: #009de0 !important;
			color: #009de0 !important;
		}
	}
}
.footer-spacer {
	position: relative;
	height: 125px;
}
@media (max-width: 321px){
	.footer-spacer {
		height: 132px;
	}
}
</style>
